import { useState } from "react";
import { featuredEvents } from "@/mocks/guaEvents";

const ALL = "全部";
const categories = [ALL, "带货翻车", "抄袭争议", "解约纠纷", "娱乐现场", "品牌热议"];

const tagMap: Record<string, string> = {
  "带货翻车": "带货翻车",
  "抄袭争议": "抄袭争议",
  "解约纠纷": "解约纠纷",
  "转会乌龙": "娱乐现场",
  "音乐争议": "娱乐现场",
  "营销翻车": "品牌热议",
};

export default function NewsFeed() {
  const [active, setActive] = useState(ALL);

  const list =
    active === ALL ? featuredEvents : featuredEvents.filter((e) => tagMap[e.tag] === active);

  return (
    <section id="news" className="w-full bg-[#f6efe3]">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <p className="text-xs font-semibold tracking-[0.2em] text-red-700">后续与最新动态</p>
            <h2 className="font-masthead mt-2 text-2xl font-black text-stone-900 md:text-3xl">
              每起事件的后续追踪
            </h2>
            <p className="mt-2 text-sm text-stone-500">
              按话题跟踪更新进度，点开即可查看每起事件的完整时间线与最新进展。
            </p>
          </div>
          <div className="flex flex-wrap items-center gap-2">
            {categories.map((c) => (
              <button
                key={c}
                onClick={() => setActive(c)}
                className={`whitespace-nowrap rounded-full border px-3.5 py-1.5 text-sm transition-colors ${
                  active === c
                    ? "border-red-700 bg-red-700 text-white"
                    : "border-orange-900/15 bg-white text-stone-600 hover:text-red-700"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((e) => (
            <article
              key={e.id}
              className="group flex flex-col overflow-hidden rounded-xl border border-orange-900/10 bg-white"
            >
              <a href="#timeline" className="block">
                <div className="relative aspect-[4/3] w-full overflow-hidden">
                  <img
                    src={e.cover}
                    alt={`${e.title} · 全网热瓜事件图片`}
                    title={`${e.title} · 全网热瓜事件图片`}
                    className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                  />
                  <span className="absolute left-3 top-3 rounded-full bg-red-700 px-2.5 py-1 text-xs font-medium text-white">
                    {e.tag}
                  </span>
                  <span className="absolute right-3 top-3 rounded-full bg-white/90 px-2.5 py-1 text-xs font-semibold text-stone-800">
                    {e.status}
                  </span>
                </div>
              </a>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <div className="mb-2 flex items-center gap-3 text-xs text-stone-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {e.time}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {e.read}
                  </span>
                </div>
                <h3 className="font-masthead text-base font-bold leading-snug text-stone-900">
                  <a href="#timeline" className="hover:text-red-700">
                    {e.title}
                  </a>
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-stone-500">{e.excerpt}</p>
                <div className="mt-4 flex items-center justify-between border-t border-orange-900/10 pt-3">
                  <span className="text-xs text-stone-400">
                    <i className="ri-chat-heart-line mr-1"></i>
                    {e.points} 条热议
                  </span>
                  <a
                    href="#timeline"
                    className="flex items-center gap-1 text-sm font-medium text-red-700 hover:text-red-800"
                  >
                    查看后续
                    <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-8 text-center">
          <button className="whitespace-nowrap rounded-md border border-red-700 bg-white px-5 py-2.5 text-sm font-medium text-red-700 transition-colors hover:bg-red-700 hover:text-white">
            <i className="ri-loader-3-line mr-1"></i>
            加载更多历史热瓜
          </button>
        </div>
      </div>
    </section>
  );
}